class DefaultModelsStore {
    // All 30 entity types initialized as empty Maps
    users = new Map();
    roles = new Map();
    sessions = new Map();
    products = new Map();
    product_categories = new Map();
    product_ingredients = new Map();
    tax_rates = new Map();
    orders = new Map();
    order_items = new Map();
    order_item_comments = new Map();
    clients = new Map();
    sectors = new Map();
    tables = new Map();
    grids = new Map();
    buttons = new Map();
    shifts = new Map();
    cash_registers = new Map();
    cash_register_transactions = new Map();
    shortcuts = new Map();
    user_transactions = new Map();
    pricelists = new Map();
    notifications = new Map();
    app_events = new Map();
    kitchen_tickets = new Map();
    order_tickets = new Map();
    terminals = new Map();
    sync_data = new Map();
    table_sessions = new Map();
    beach_zones = new Map();
    beach_bookings = new Map();
    order_requests = new Map();
    payment_sessions = new Map();
    // Getters
    all(entity) {
        const map = this[entity];
        if (map instanceof Map) {
            return Array.from(map.values());
        }
        return [];
    }
    find(entity, _primaryKey, id) {
        const map = this[entity];
        if (map instanceof Map) {
            return map.get(id);
        }
        return undefined;
    }
    // Actions
    init(payload) {
        const entity = payload.model.entity;
        if (!entity || !this[entity])
            return;
        // Clear the map
        this[entity].clear();
        this.insertOrUpdate(payload);
    }
    // `create` replaces the collection, like the apps' Pinia store — `Model.deleteAll()`
    // and every SyncData cleanup rely on it (`create({ data: [] })` must empty the map).
    create(payload) {
        // create() replaces the entity's records (Vuex-ORM/Pinia store semantics —
        // Model.deleteAll() relies on `create({ data: [] })` clearing the collection).
        const entity = payload.model.entity;
        if (!entity || !this[entity])
            return;
        this[entity].clear();
        this.insertOrUpdate(payload);
    }
    insert(payload) {
        this.insertOrUpdate(payload);
    }
    update(payload) {
        this.insertOrUpdate(payload);
    }
    insertOrUpdate(payload) {
        const entity = payload.model.entity;
        if (!entity || !this[entity])
            return;
        // primaryKey is a STATIC on the model class — reading it off the instance
        // returns undefined and silently drops every record.
        const primaryKey = payload.model.primaryKey;
        const map = this[entity];
        const dataArray = Array.isArray(payload.data) ? payload.data : [payload.data];
        for (const item of dataArray) {
            // Look up any existing row by the RAW item's key first — a hash-keyed
            // model (primaryKey 'hash') omits the key entirely when the caller
            // means "create a new record, generate its hash" (the field default
            // generates it), so an absent key here is not an error, it is
            // that case; reading model[primaryKey] AFTER construction (below)
            // recovers the generated id exactly as before this merge behavior
            // was added.
            const rawId = item?.[primaryKey];
            // Merge onto whatever is already held for this key — a partial record
            // (a sync response or a peer broadcast carrying only some fields) must
            // not blank out fields it omits by re-filling the model from scratch;
            // $fill() defaults any field missing from `item`, silently corrupting
            // the stored row (mirrors the fix in useModelsStore.insert()). init()/
            // create() clear the map before calling this, so there is never an
            // existing row to merge with there — this only changes insert()/update().
            const existing = rawId !== undefined ? map.get(rawId) : undefined;
            const merged = existing ? { ...existing.$toJson(), ...item } : item;
            const model = new payload.model(merged);
            const id = model[primaryKey];
            if (id !== undefined) {
                map.set(id, model);
            }
        }
    }
    delete(payload) {
        const entity = payload.model.entity;
        if (!entity || !this[entity])
            return;
        const primaryKey = payload.model.primaryKey;
        const dataArray = Array.isArray(payload.data) ? payload.data : [payload.data];
        for (const item of dataArray) {
            const model = new payload.model(item);
            const id = model[primaryKey];
            if (id !== undefined) {
                this[entity].delete(id);
            }
        }
    }
}
export const defaultModelsStore = new DefaultModelsStore();
//# sourceMappingURL=DefaultModelsStore.js.map